<div class="group5">
  <h4 style="margin-top: 0;" *ngIf="!hidetitle"> Amiante </h4>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht51">
      <label class="col-sm-3 champ" style="padding:0px"> Entreprise de travaux : </label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div *ngIf="!edit">{{ chantier.entrepriseTravaux ? (chantier.entrepriseTravaux.libelleObjetEntite || entreprise)  : '' }}</div>
        <div *ngIf="edit" >
            <app-autocomplete [placeholder]="''" (searchfunction)="searchEntreprise($event)" (selectfunction)="chantier.entrepriseTravaux = $event"
            [results]="resultEntreprise" [label]="''" [defaultsearch]="chantier.entrepriseTravaux ? (chantier.entrepriseTravaux.libelleObjetEntite || entreprise) : ''" ></app-autocomplete>
          </div>
      </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht52">
    <label class="col-sm-3 champ" style="padding:0px"> Maître d'ouvrage : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.maitreOuvrage ? (chantier.maitreOuvrage.libelleObjetEntite || maitreOuvrage) : '' }}</div>
      <div *ngIf="edit" >
          <app-autocomplete [placeholder]="''" (searchfunction)="searchMaitre($event)" (selectfunction)="chantier.maitreOuvrage = $event"
          [results]="resultMaitre" [label]="''" [defaultsearch]="chantier.maitreOuvrage ? (chantier.maitreOuvrage.libelleObjetEntite || maitreOuvrage) : ''" ></app-autocomplete>
        </div>
    </div>
  </div>
</div>
